import { AddPaymentInfo, commissionPaymentRequest, MultiplePaymentsObj, PaymentNotes, PaymentRequest, RecordPayoutInfo, SearchPaymentRequest } from "../redux/slice/payment/paymentSlice";
import { InterceptorOption } from "../types/CommonTypes";
import { ADD_PAYMENT_NOTE_URL, ADD_PAYMENTS_URL, GET_PAYMENT_BY_ID_URL, GET_PAYMENTS_BY_INVOICE_ID_URL, LIST_PAYMENT_NOTES_URL, RECORD_MULTIPLE_PAYMENTS_URL, SAVE_COMMISSION_PAYOUTS_URL, SAVE_MULTIPLE_COMMISSION_PAYOUTS_URL, SEARCH_PAYMENTS_URL, UPLOAD_COMMISSION_PAYMENT_URL, UPLOAD_PAYMENT_URL, VOID_PAYMENT_URL } from "./URL";
import { http } from "./http";


export const uploadPaymentFileData = async (paymentData: PaymentRequest, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.post(UPLOAD_PAYMENT_URL, paymentData, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};

export const uploadCommissionPaymentFileData = async (commissionData: commissionPaymentRequest, interceptorOption: InterceptorOption) => {
  try {
    const response = await http.post(UPLOAD_COMMISSION_PAYMENT_URL, commissionData, undefined, interceptorOption);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveAgencyCommissionPayoutData = async (data: RecordPayoutInfo) => {
  try {
    const response = await http.post(SAVE_COMMISSION_PAYOUTS_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveMultipleCommissionsService = async (data: RecordPayoutInfo) => {
  try {
    const response = await http.post(SAVE_MULTIPLE_COMMISSION_PAYOUTS_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveInvoicePaymentData = async(data:AddPaymentInfo)=>{
  try{
    const response =await http.post(ADD_PAYMENTS_URL,data);
    return response;
  }catch(error){
    throw error;
  }
}

export const paymentSearchService = async(data:SearchPaymentRequest)=>{
  try{
    const response =await http.post(SEARCH_PAYMENTS_URL,data);
    return response;
  }catch(error){
    throw error;
  }
};

// CS - 1216 Start
export const addMultiplePaymentRecord = async (data: MultiplePaymentsObj) => {
  try {
    const response = await http.post(RECORD_MULTIPLE_PAYMENTS_URL, data);
    return response;
  } catch (error) {
    throw error;
  }
};
// CS - 1216 End

//CS-1212 - Start
export const uploadPaymentNotesData = async (ivrNotesObjecct: PaymentNotes) => {
  try {
    const response = await http.post(ADD_PAYMENT_NOTE_URL, ivrNotesObjecct);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentNoteById = async (xrefTableId: number, xrefTable: any) => {
  try {
    const response = await http.post(LIST_PAYMENT_NOTES_URL, null, {
      params: {
        xrefTableId,
        xrefTable,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
}
//CS-1212 - End

export const voidPaymentService = async (data: number) => {
  try {
    const response = await http.post(`${VOID_PAYMENT_URL}?paymentId=${data}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const paymentById = async (data: number) => {
  try {
    const response = await http.post(`${GET_PAYMENT_BY_ID_URL}?paymentId=${data}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentsByInvoiceId = async (invoiceId: number) => {
  try {
    const response = await http.get(`${GET_PAYMENTS_BY_INVOICE_ID_URL}?invoiceId=${invoiceId}`);
    return response;
  } catch (error) {
    throw error;
  }
};